// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from TabBar-Button.module.scss  */
.TabBar-Button-module-Root_5-w {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  margin: 0;
  padding: 0;
  font-family: var(--tab-bar-font-family);
  font-size: var(--tab-bar-font-size);
  line-height: var(--tab-bar-line-height);
  user-select: none;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;
  letter-spacing: var(--tab-bar-letter-spacing);
  color: var(--tab-bar-text-color);
  border-width: 0;
  outline: 0;
  background: transparent;
  -moz-user-focus: ignore;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  touch-action: manipulation; }

.TabBar-Button-module-TabBarButtonIconContainer_2df {
  position: relative;
  display: inline-block; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/TabBar/Button/TabBar-Button.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,UAAU;EACV,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;EACvC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,uBAAuB;EACvB,6CAA6C;EAC7C,0BAA0B,EAAE;;AAE9B;EACE,kBAAkB;EAClB,qBAAqB,EAAE","sourcesContent":["/*  imported from TabBar-Button.module.scss  */\n.TabBar-Button-module-Root_5-w {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n  align-items: center;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  font-family: var(--tab-bar-font-family);\n  font-size: var(--tab-bar-font-size);\n  line-height: var(--tab-bar-line-height);\n  user-select: none;\n  text-align: center;\n  white-space: nowrap;\n  text-decoration: none;\n  letter-spacing: var(--tab-bar-letter-spacing);\n  color: var(--tab-bar-text-color);\n  border-width: 0;\n  outline: 0;\n  background: transparent;\n  -moz-user-focus: ignore;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  touch-action: manipulation; }\n\n.TabBar-Button-module-TabBarButtonIconContainer_2df {\n  position: relative;\n  display: inline-block; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
